import {
  Box,
  chakra,
  Flex,
  useColorModeValue,
  Link,
  AspectRatio,
  Stack,
  Text,
  Center,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  useDisclosure,
  ModalCloseButton,
  Image,
} from '@chakra-ui/react';

import { SlideData } from "./projectimages.js";

import { Component } from 'react';
import ReactDOM from 'react-dom';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from '../../node_modules/react-responsive-carousel/';
// ../../node_modules/react-responsive-carousel/lib/styles/carousel.min.css 
import ProjectModal_core3 from './projectmodal_core3.js';
import ProjectModal_core2 from './projectmodal_core2.js';
import ProjectModal_tech4 from './projectmodal_tech4.js';
import ProjectModal_adr2 from './projectmodal_adr2.js';


import { TfiClose } from "react-icons/tfi";
import { ChevronRightIcon, CloseIcon } from '@chakra-ui/icons';

import React, { } from "react";
import { FaYoutube } from "react-icons/fa";
// import ContactInfoGoogleMapsSplit from './ContactInfoGoogleMapsSplit';

//hero images for each project
import tech4_aerial from '../assets/tech4_aerial.png';
import core2_foodmarket from '../assets/core2_foodmarket.png';
import core3_entrance from '../assets/core3_entrance2_a5 eye level.png';
import adr1 from '../assets/adr/adr1.gif';
import adr2 from '../assets/adr/I_CityTypologysq.gif';
import adr2hero from '../assets/adr/adr2_hero.png';
import d1hero from '../assets/d1/d1_fk_analysis.png';

export default function Projects() {
  return (
    <Box>

      {/* core 3 */}
      <div id='cityhouseliving'>
        <Box 
        mt={{ base: 20, md: 20 }} px={6}
        >
          <Core3 />
        </Box>
      </div>

      {/* core 2 */}
      <div id='bioregeneration'>
        <Box mt={{ base: 20, md: 20 }} px={6}>
          <Core2 />
        </Box>
      </div>

      {/* tech 4 */}
      <div id='urbanagriscape'>
        <Box mt={{ base: 20, md: 20 }} px={6}>
          <Tech4 />
        </Box>
      </div>

      {/* adr1 */}
      <div id='recycledlittleisland'>
        <Box mt={{ base: 20, md: 20 }} px={6}>
          <ADR1 />
        </Box>
      </div>

      {/* adr2 */}
      {/* <div id='generativecitydesign'>
        <Box mt={{ base: 20, md: 20 }} px={6}>
          <ADR2 />
        </Box>
      </div> */}





      <div id='video2'><Box mt={{ base: 10, md: 20 }} px={6}><Video2 /></Box></div>

    </Box>
  );
}


// Core2: Urban Renewal and Bioregeneration
function Core2() {
  return (

    <Stack
      // minH={'100vh'} 
      direction={{ base: 'column', md: 'row-reverse' }}>
      <Flex
        flex={1} align={'center'} justify={'center'} textAlign='center'>

        <Stack
          spacing={6}
          maxW={{ base: 'full', lg: 'lg' }}
        >
          <chakra.p
            color='gray.400'
            fontSize='sm'
            letterSpacing={2}
            fontWeight='light'
            textAlign='center'
            textTransform='uppercase'
            lineHeight='0.9'
            mb={2}
          >
            gsapp core 2 | S2023
          </chakra.p>
          <chakra.p
            fontSize={{base:'3xl',sm:'4xl'}}
            letterSpacing={2}
            color={useColorModeValue('black', 'white')}
            fontWeight='thin'
            textAlign='center'
            textTransform='uppercase'
            lineHeight='1'
            mt={"10px"}
            mb={"10px"}
          >
            Urban Renewal and Bioregeneration
          </chakra.p>
          <Text textAlign='center' fontStyle='italic' fontWeight='light' fontSize={{ base: 'sm', lg: 'sm' }} color={'gray.400'}>
            Critic: Josh Uhl
            <br />
          </Text>
          <Text textAlign='left' fontWeight='light' fontSize={{ base: 'sm', lg: 'sm' }}
            color={useColorModeValue('gray.800', 'gray.200')}
          >
            📍 Ironbound, Newark, NJ
            <br/><br/>While damaging pollutants are phytostabilized, individuals find ways to inhabit and make the biophilic and civic space their own, and in turn give form to programs they identify with; the aspiration for the space is to appeal, invite, uplift.
            <br />
            <br />

            <Link href="https://www.youtube.com/watch?v=c47Y7_z9R7E&ab_channel=SharelLiu" isExternal>
              <HStack>
                <FaYoutube /><Text fontWeight='medium'>Urban Renewal & Bioregenerative Concept | Sharel SJ</Text>
              </HStack>
            </Link>
            <Link href="https://www.arch.columbia.edu/student-work/11784-civic-space-for-bioregeneration-and-urban-renewal" isExternal>
              <HStack>
                <Text fontWeight='medium'>GSAPP Feature: Civic Space for Bioregeneration and Urban Renewal</Text>
              </HStack>
            </Link>
            

            <br /><br />
            <Box mb={{ base: 4, md: 'none' }}><ProjectModal_core2/></Box>
          </Text>
        </Stack>
      </Flex>

      <Flex flex={1} >
        <Center
          rounded={'2xl'}
          boxShadow={'2xl'}
          w={'100%'}
          h={{ base: '300px', md: '600px' }}
          mr={{ base: 0, md: 6 }}
          backgroundImage={core2_foodmarket}
          alt='gsapp project on urban agriscape'
          backgroundSize={'cover'}
          backgroundPosition={'right right'}
        // position={'center,center'}  
        >
        </Center>
      </Flex>
    </Stack>
  );
}

// Tech4: Farm to City: Urban Agriscape
function Tech4() {
  return (

    <Stack
      // minH={'100vh'} 
      direction={{ base: 'column', md: 'row' }}>
      <Flex
        // px={6} 
        flex={1} align={'center'} justify={'center'} textAlign='center'>

        <Stack
          maxW={{ base: 'full', lg: 'lg' }}
        >
          <chakra.p
            color='gray.400'
            fontSize='sm'
            letterSpacing={2}
            fontWeight='light'
            textAlign='center'
            textTransform='uppercase'
            lineHeight='0.9'
            mb={2}
          >
            gsapp tech 4 | F2023
          </chakra.p>
          <chakra.p
            fontSize={{base:'3xl',sm:'4xl'}}
            letterSpacing={2}
            color={useColorModeValue('black', 'white')}
            fontWeight='thin'
            textAlign='center'
            textTransform='uppercase'
            lineHeight='1'
            mt={"10px"}
            mb={"10px"}
          >
            farm to city: urban agriscape
          </chakra.p>
          <Text textAlign='center' fontStyle='italic' fontWeight='light' fontSize={{ base: 'sm', lg: 'sm' }} color={'gray.400'}>
            Critics: Joe Hand, Paul Laroque, Sigal Shemesh, Alex Barmas
            <br /> 
          </Text>
          <Text textAlign='left' fontWeight='light' fontSize={{ base: 'sm', lg: 'sm' }}
            // color={'gray.800'}
            color={useColorModeValue('gray.800', 'gray.200')}
          >
            📍 281-285 Ferry St, Ironbound, Newark, NJ 07105
            <br/><br/>Conceived in Core 2 studio and selected for further development in a group setting* in Tech 4 on building systems integration, this project is on revitalizing surface parking in Ironbound, NJ, into programs including a civic center, assisted living and urban farms.
            <br />
            <br />
            <Text fontSize='2xs'>*Group: Sharel Liu, Rory Peckham, Brandon Gil, Lucy Li, Hunter Wolff, Russell Liang</Text>
            <br />
            <Link href="https://www.youtube.com/watch?v=ijSXzEA5j6c&ab_channel=SharelSJ" isExternal>
              <HStack>
                <FaYoutube /><Text fontWeight='medium'>Farm to City: Urban Agriscape | Sharel SJ</Text>
              </HStack>
            </Link>
            <br /><br />
            <Box mb={{ base: 4, md: 'none' }}><ProjectModal_tech4/></Box>
          </Text>
        </Stack>

      </Flex>
      <Flex flex={1} >
        <Center
          rounded={'2xl'}
          boxShadow={'2xl'}
          w={'100%'}
          h={{ base: '300px', md: '600px' }}
          mr={{ base: 0, md: 6 }}
          backgroundImage={tech4_aerial}
          alt='gsapp project on urban agriscape'
          backgroundSize={'cover'}
          backgroundPosition={'right right'}
        // position={'center,center'}  
        >
        </Center>
      </Flex>
    </Stack>
  );
}

// Core3: Intergenerational Biophilic Housing in New York
function Core3() {
  return (

    <Stack
      direction={{ base: 'column', md: 'row' }}>
      <Flex
        flex={1} align={'center'} justify={'center'} textAlign='center'>

        <Stack maxW={{ base: 'full', lg: 'lg' }}>
          <chakra.p
            color='gray.400'
            fontSize='sm'
            letterSpacing={2}
            fontWeight='light'
            textAlign='center'
            textTransform='uppercase'
            lineHeight='0.9'
            mb={2}
          >
            gsapp core 3 | F2023
          </chakra.p>
          <chakra.p
            fontSize={{base:'3xl',sm:'4xl'}}
            letterSpacing={2}
            color={useColorModeValue('black', 'white')}
            fontWeight='thin'
            textAlign='center'
            textTransform='uppercase'
            lineHeight='1'
            mt={"10px"}
            mb={"10px"}
          >
            Intergenerational Urban House Living
          </chakra.p>
          <Text textAlign='center' 
          fontStyle='italic' 
          fontWeight='light' fontSize={{ base: 'sm', lg: 'sm' }} 
          color={'gray.400'}
          >
            Critic: Eric Bunge
          </Text>
          <Text textAlign='left' fontWeight='light' fontSize={{ base: 'sm', lg: 'sm' }}
            color={useColorModeValue('gray.800', 'gray.200')}
          >
            📍 New York, NY
            <br/><br/>
            Responding to the need for mass housing, connection to nature, and the sustainable adaptative reuse of existing infrastructure, the project pursues the idea of combining the best of suburban house living, community, and re-interprets intergenerational living for an urban context. The language of walls comes from extending the existing column structure of a former building on the site.
            <br />
            <br />
            {/* <Text fontSize='3xs'>*Group: Russell Liang</Text> */}
            <br />
            <Link href="https://www.youtube.com/watch?v=gbiW1ZLx3Vo&ab_channel=SharelSJ" isExternal>
              <HStack>
                <FaYoutube /><Text fontWeight='medium'>Living Between Walls | Sharel SJ</Text>
              </HStack>
            </Link>
            <br /><br />
            <Box mb={{ base: 4, md: 'none' }}><ProjectModal_core3/></Box>
          </Text>
        </Stack>

      </Flex>
      <Flex flex={1} >
        <Center
          rounded={'2xl'}
          boxShadow={'2xl'}
          w={'100%'}
          h={{ base: '300px', md: '600px' }}
          mr={{ base: 0, md: 6 }}
          backgroundImage={core3_entrance}
          alt='gsapp project on urban agriscape'
          backgroundSize={'cover'}
          backgroundPosition={'right right'}
        // position={'center,center'}  
        >
        </Center>
      </Flex>
    </Stack>
  );
}

// ADR1: Little Island
function ADR1() {
  return (

    <Stack
      direction={{ base: 'column', md: 'row-reverse' }}>
      <Flex
        flex={1} align={'center'} justify={'center'} textAlign='center'>

        <Stack maxW={{ base: 'full', lg: 'lg' }}>
          <chakra.p
            color='gray.400'
            fontSize='sm'
            letterSpacing={2}
            fontWeight='light'
            textAlign='center'
            textTransform='uppercase'
            lineHeight='0.9'
            mb={2}
          >
            <Link href='https://www.arch.columbia.edu/courses/12384-3898' isExternal>
            gsapp ADR 1 | F2022
            </Link>
          </chakra.p>
          <chakra.p
            fontSize={{base:'3xl',sm:'4xl'}}
            letterSpacing={2}
            color={useColorModeValue('black', 'white')}
            fontWeight='thin'
            textAlign='center'
            textTransform='uppercase'
            lineHeight='1'
            mt={"10px"}
            mb={"10px"}
          >
            Recycled "Little Island"
          </chakra.p>
          <Text textAlign='center' 
          fontStyle='italic' 
          fontWeight='light' fontSize={{ base: 'sm', lg: 'sm' }} 
          color={'gray.400'}
          >
            Critic: Ray Wang
          </Text>
          <Text textAlign='left' fontWeight='light' fontSize={{ base: 'sm', lg: 'sm' }}
            color={useColorModeValue('gray.800', 'gray.200')}
          >
            📍 New York, NY

            <br/><br/>
            I chose <Link href='https://littleisland.org/' isExternal>
            Heatherwick Studio's Little Island</Link> for the representation exercise in ADR1 ("Architectural Design and Representation 1"). The model engages with the idea of exclusively using recycled materials to highlight the inherent beauty found in recycled materials, showcasing a sustainable and aesthetically pleasing approach.
            <br/><br/>
            <Box mb={{ base: 4, md: 'none' }}><Link fontWeight={'medium'}href="https://www.arch.columbia.edu/student-work/11468" isExternal>
              GSAPP Feature: ADR1</Link></Box>
          </Text>
          
        </Stack>

      </Flex>
      <Flex flex={1} >
        <Center
          rounded={'2xl'}
          boxShadow={'2xl'}
          w={'100%'}
          h={{ base: '300px', md: '600px' }}
          mr={{ base: 0, md: 6 }}
          backgroundImage={adr1}
          alt='ADR1'
          backgroundSize={'cover'}
          backgroundPosition={'right right'}
        // position={'center,center'}  
        >
        </Center>
      </Flex>
    </Stack>
  );
}

// ADR2: Building Combos
function ADR2() {
  return (

    <Stack
      direction={{ base: 'column', md: 'row' }}>
      <Flex
        flex={1} align={'center'} justify={'center'} textAlign='center'>

        <Stack maxW={{ base: 'full', lg: 'lg' }}>
          <chakra.p
            color='gray.400'
            fontSize='sm'
            letterSpacing={2}
            fontWeight='light'
            textAlign='center'
            textTransform='uppercase'
            lineHeight='0.9'
            mb={2}
          >
            GSAPP ADR2 | S2023
          </chakra.p>
          <chakra.p
            fontSize={{base:'3xl',sm:'4xl'}}
            letterSpacing={2}
            color={useColorModeValue('black', 'white')}
            fontWeight='thin'
            textAlign='center'
            textTransform='uppercase'
            lineHeight='1'
            mt={"10px"}
            mb={"10px"}
          >
            Generative City Design
          </chakra.p>
          <Text textAlign='center' 
          fontStyle='italic' 
          fontWeight='light' fontSize={{ base: 'sm', lg: 'sm' }} 
          color={'gray.400'}
          >
            Critic: Stella Ioannidou
          </Text>
          <Text textAlign='left' fontWeight='light' fontSize={{ base: 'sm', lg: 'sm' }}
            color={useColorModeValue('gray.800', 'gray.200')}
          >
            📍 Urban Conditions Worldwide: Athens, Toledo, Paris, Newark, Berlin, Mountain View
            <br /><br />
            Urban conditions worldwide, encompassing cities such as Athens, Toledo, Paris, Newark, Berlin, and Mountain View, underwent a comprehensive study aimed at identifying optimal conditions for city design. The insights derived from this investigation, facilitated through the utilization of Grasshopper and Rhino, were subsequently employed to enhance and refine the existing urban conditions within the framework of the <Link href='#bioregeneration'>Core 2 project based in Newark, NJ</Link>.
            {/* Assumptions
            n = 24 lots per block, r = 4 possible heights (12, 24, 36, 42ft) → nCr = 10,626 combinations
            <br /><br />
            Methodology
            (1) Urban Typology → (2) Street Orientation → (3) Block Building Heights
            Constant: Newark lot sizes
            <br /><br />
            Resources
            Newark, NJ §41:5-4-2 Single-Family House (ecode360.com/36749294)
            OSM
            Google Earth */}

            <br />
            <br />
            <Link href="https://www.youtube.com/watch?v=gWwTE1SwQIc&ab_channel=SharelLiu" isExternal>
              <HStack>
                <FaYoutube /><Text fontWeight='medium'>Testing 10,626 Building Combinations | Sharel SJ</Text>
              </HStack>
            </Link>
            <Link href="https://www.youtube.com/watch?v=_16CEV2Jgew&ab_channel=SharelLiu" isExternal>
              <HStack>
                <FaYoutube /><Text fontWeight='medium'>
                  
                Testing 360 Degrees of Street Orientation | Sharel SJ</Text>
              </HStack>
            </Link>


            
            <br /><br />
            <Box mb={{ base: 4, md: 'none' }}><ProjectModal_adr2/>
            </Box>
          </Text>
        </Stack>

      </Flex>
      <Flex flex={1} >
        <Center
          rounded={'2xl'}
          boxShadow={'2xl'}
          w={'100%'}
          h={{ base: '300px', md: '600px' }}
          mr={{ base: 0, md: 6 }}
          backgroundImage={adr2hero}
          alt='gsapp project on urban agriscape'
          backgroundSize={'cover'}
          backgroundPosition={'right right'}
        >
        </Center>
      </Flex>
    </Stack>
  );
}

function Video2() {
  return (
    <Flex>
      <AspectRatio ratio={1}
        w="full"
        position={'relative'}
        h={'580px'}
        rounded={'2xl'}
        boxShadow={'2xl'}
        overflow={'hidden'}
      //  maxW='560px'
      >
        <iframe
          title='Farm to Table: Urban Agriscape'
          width="560" height="315" src="https://www.youtube.com/embed/ijSXzEA5j6c?si=OZDbqbXXsracJHWW"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen></iframe>
      </AspectRatio>

    </Flex>

  );
}
